import './Home.css';

export default function Home() {
    return (
        <div className="Home">
            <div className="Content">
                <p>Hi! Welcome to <span className="pinkGlow">Munamii Cakery</span>!</p>
                <p>We offer you the most delicious cakes and cupcakes for all kinds of events and celebrations.</p>
                <p>Browse around to discover what you would like to buy.</p>
            </div>
        </div>
    )
}